import React from 'react';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Page, TLCode } from '../../common/enums';
import VerticalForm from '../common/form/VerticalForm';
import BaseGrid from '../common/grid/BaseGrid';
import BaseGridXL from '../common/grid/BaseGridXL';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Instance } from 'mobx-state-tree';
import styled from '@emotion/styled';
import EditCell from '../common/grid/EditCell';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface NeighborsPanelProps extends WithTranslateProps {
  pharmacyDetails: Instance<typeof PharmacyDetails>;
  ApplicationStore?: any;
  getPharmacy: (id: number) => Instance<typeof PharmacyDetails>;
  isPharmacy: boolean;
}

class NeighborsPanel extends React.Component<NeighborsPanelProps> {
  getColumnDefs = (): ColDef[] => {
    const { translate, isPharmacy } = this.props;
    const cols = [
      {
        headerName: translate(TLCode.PHARMACIES_ApbNum),
        field: 'apbNumber',
        width: 75,
        minWidth: 75,
        maxWidth: 75,
        sortable: true,
      },
      {
        headerName: translate(TLCode.PHARMACIES_PharmacyName),
        field: 'name',
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: translate(TLCode.PHARMACIES_Address),
        field: 'address',
        width: 300,
        minWidth: 300,
      },
      {
        headerName: translate(TLCode.PHARMACIES_ZipCode),
        field: 'zipCode',
        width: 60,
      },
      {
        headerName: translate(TLCode.PHARMACIES_City),
        field: 'city',
        width: 100,
      },
      {
        headerName: translate(TLCode.PHARMACIES_Level),
        field: 'level',
        width: 60,
        sortable: true,
      },
      {
        headerName: translate(TLCode.PHARMACIES_Distance),
        field: 'distance',
        width: 100,
        sortable: true,
        sort: 'asc',
      },
      // {
      //   headerName: translate(TLCode.PHARMACIES_Distance),
      //   field: 'drivingDistance',
      //   width: 100,
      //   sortable: true,
      //   sort: 'asc',
      // },
      {
        headerName: translate(TLCode.PHARMACIES_Density),
        field: 'density',
        width: 100,
        sortable: true,
      },
      {
        headerName: translate(TLCode.PHARMACIES_Anchor),
        field: 'anchor',
        width: 100,
        sortable: true,
      },
      {
        headerName: translate(TLCode.PHARMACIES_Group),
        field: 'group',
        width: 100,
        sortable: true,
      },
      {
        headerName: translate(TLCode.PHARMACIES_Active),
        field: 'active',
        width: 100,
        sortable: true,
        cellRendererFramework: this.renderStatus,
      },
    ];

    if (!isPharmacy) {
      cols.push({
        headerName: '',
        width: 100,
        // @ts-ignore
        cellRendererFramework: EditCell,
        cellRendererParams: (params: ICellRendererParams) => {
          return {
            onEditButtonClick: () => {
              this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${params.data.pharmacyId}`);
            },
          };
        },
      });
    }

    return cols;
  };

  renderStatus = (row) => {
    return row.data.active ? '' : 'non';
  };

  buildGridData = () => {
    const neighbors = this.props.pharmacyDetails.neighbors();
    return neighbors
      .filter((p) => p !== undefined)
      .map(
        (p) =>
          p && {
            pharmacyId: p.pharmacyId,
            apbNumber: p.apbNumber,
            name: p.name,
            level: p.level,
            phone: p.phone,
            address: p.address,
            city: p.city,
            zipCode: p.zipCode,
            density: p.density,
            distance: this.props.pharmacyDetails.pharmacyNeighbors.find((pn) => pn.neighborId === p.pharmacyId)!
              .distance,
            zone: p.zoneId,
            anchor: p.anchor,
            group: p.group,
            active: p.isActive
          },
      );
  };

  onPharmacySelected = (event) => {
    const pharmacyId = event.data.pharmacyId;
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyId}`);
  };

  render() {
    const { pharmacyDetails } = this.props;
    return (
      <Container>
        <VerticalForm labelWidth={175}>
          <b>
            ({pharmacyDetails!.level})&nbsp;&nbsp;{pharmacyDetails.apbNumber}&nbsp;-&nbsp;{pharmacyDetails.name}
            &nbsp;-&nbsp;{pharmacyDetails.address},&nbsp;
            {pharmacyDetails.city}&nbsp;
            {pharmacyDetails.zipCode}
          </b>
          Jour rayon min(m): {pharmacyDetails.minDistance}&nbsp;max(m): {pharmacyDetails.maxDistance}&nbsp;&nbsp;Nuit
          rayon min(m): {pharmacyDetails.minDistance2}&nbsp;max(m): {pharmacyDetails.maxDistance2}
          <br />
        </VerticalForm>
        <Container>
          <BaseGridXL
            keyName="pharmacyId"
            columnDefs={this.getColumnDefs()}
            rowData={this.buildGridData()}
            onRowDoubleClicked={this.onPharmacySelected} />
        </Container>
      </Container>
    );
  }
}

export default withTranslate(NeighborsPanel);
